


































import Vue from 'vue';
import ButtonComponent from './button.component.vue';
export default Vue.extend({
    name: 'modal',
    components: {
        ButtonComponent
    },
    props: {
        header: String,
        body: String,
        buttonLeft: String,
        buttonRight: String
    },
    methods: {
        close() {
            this.$emit('close');
        },
        onDeleteClicked() {
            this.$emit('onDeleteClicked');
        }
    },
});
